import React, { useState, useEffect } from "react";
import { fetchUsersByRole } from "../../../api";
import { USER_ROLES } from "../../constants";
import { FaUserFriends } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import "../PatientsList/PatientsList.css";

const LabelerList = ({ selectedLabelerId, onLabelerClick }) => {
  const [labelers, setLabelers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const loadLabelers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetchUsersByRole(USER_ROLES.LABELER);
      // Handle different response structures
      const labelersList = Array.isArray(response) 
        ? response 
        : (response?.users || response?.data || []);
      setLabelers(labelersList);
    } catch (error) {
      console.error("Error loading labelers:", error);
      setError("Failed to load labelers");
      setLabelers([]); // Ensure labelers is always an array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLabelers();
  }, []);

  const handleLabelerClick = (labeler) => {
    if (onLabelerClick) {
      onLabelerClick(labeler);
    }
  };

  const getAllLabelers = () => {
    return labelers || [];
  };

  const getFilteredLabelers = () => {
    let filteredLabelers = getAllLabelers();

    if (searchInput) {
      filteredLabelers = filteredLabelers.filter(
        (labeler) =>
          labeler.full_name
            ?.toLowerCase()
            .includes(searchInput.toLowerCase()) ||
          labeler.email?.toLowerCase().includes(searchInput.toLowerCase()) ||
          labeler.username?.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    return filteredLabelers;
  };

  const getFilteredCounts = () => {
    const allLabelers = labelers || [];

    const filteredAll = searchInput
      ? allLabelers.filter(
          (labeler) =>
            labeler.full_name
              ?.toLowerCase()
              .includes(searchInput.toLowerCase()) ||
            labeler.email?.toLowerCase().includes(searchInput.toLowerCase()) ||
            labeler.username?.toLowerCase().includes(searchInput.toLowerCase())
        )
      : allLabelers;

    return {
      total: filteredAll.length,
      active: 0,
      inactive: 0,
    };
  };



  if (loading) {
    return (
      <div className="patients-container">
        <div className="loading-message">Loading Labelers...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="patients-container">
        <div className="error-message">
          <p>{error}</p>
          <button onClick={loadLabelers}>Retry</button>
        </div>
      </div>
    );
  }

  const filteredLabelers = getFilteredLabelers();
  const filteredCounts = getFilteredCounts();

  return (
    <div className="patients-container">
      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-icon-wrapper first">
            <FaUserFriends className="stat-icon" />
          </div>
          <div className="stat-content">
            <span className="stat-label">
              Total Labelers {searchInput && "(filtered)"}
            </span>
            <span className="stat-value">{filteredCounts.total}</span>
          </div>
        </div>
      </div>

      <div className="patients-table-container">
        <div className="table-header">
          <div className="table-controls">
            <div className="search-container">
              <IoSearchOutline className="search-icon" />
              <input
                placeholder="Search Labelers..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
        </div>

        <div className="patients-table">
          <div className="table-header-row three-columns">
            <span className="header-cell">Name</span>
            <span className="header-cell">Email</span>
            <span className="header-cell">Actions</span>
          </div>

          {filteredLabelers.map((labeler, index) => (
            <div key={labeler.username || labeler.email || index} className="table-row three-columns">
              <span className="table-cell patient-name">
                {labeler.full_name}
              </span>
              <span className="table-cell">{labeler.email || 'N/A'}</span>
              <span className="table-cell">
                <button
                  className="action-button"
                  onClick={() => handleLabelerClick(labeler)}
                >
                  View
                </button>
              </span>
            </div>
          ))}

          {filteredLabelers.length === 0 && (
            <div className="no-data-row">
              <span className="no-data-message">
                {searchInput
                  ? "No Labelers found matching your search."
                  : "No Labelers available."}
              </span>
            </div>
          )}
        </div>

        <div className="table-footer">
          <span className="table-info">
            Showing {filteredLabelers.length} of {filteredCounts.total} Labelers
          </span>
        </div>
      </div>
    </div>
  );
};

export default LabelerList;
